export const GoogleMapApiConfig = 'AIzaSyApVoYCwq7WqqEIn-dpc7yfr2Rmxw31bfM';